<div class="contractor-card-v2">
  <!-- Header: Avatar + Identity + Stats -->
  <div class="card-header">
    <div class="header-main">
      <div class="avatar-section">
        <div class="avatar-container">
          <img class="avatar-img" [src]="staffer.profileImage" alt="Contractor">
          <div *ngIf="staffer.staffer.isStafferVerified" class="verified-badge">
            <i class="fa fa-check"></i>
          </div>
          <div *ngIf="staffer?.staffer?.badges?.indexOf('covid-19-vaccine') > -1" class="covid-badge">
            <img src="assets/images/Covid-Badge.svg">
          </div>
        </div>
      </div>
      
      <div class="identity-section">
        <div class="name-row">
          <span class="staffer-name">{{staffer.staffer.firstName}} {{staffer.staffer.lastName}}</span>
          <div class="contact-icons" *ngIf="shouldShowPhoneNumber">
            <a *ngIf="staffer.staffer.phoneNumber" [href]="'tel:' + staffer.staffer.phoneNumber" class="contact-link">
              <i class="fas fa-phone-alt"></i>
            </a>
            <span *ngIf="staffer.staffer.email" class="contact-link email-pop" (mouseenter)="showPopover('email')" (mouseleave)="hidePopover()" (click)="handleEmailCopyToClipBoard()">
              <i class="fas fa-envelope"></i>
              <app-copy-popover [copiedToClipBoard]="emailCopied" [showPopover]="showEmailPopOver" [text]="staffer.staffer.email"></app-copy-popover>
            </span>
          </div>
        </div>
        
        <div class="meta-row">
          <div class="rating-badge" *ngIf="staffer.staffer.numOfRatedUsers > 3 && staffer.staffer.aggregated_rating > 0">
            <i class="fas fa-star"></i>
            <span>{{staffer.staffer.aggregated_rating}}</span>
            <span class="count">({{staffer.staffer.numOfRatedUsers}})</span>
          </div>
          <span class="shifts-completed">{{staffer.staffer.shifts_completed || 0}} shifts completed</span>
        </div>

        <div class="badges-row" *ngIf="staffer.staffer.badges.length">
          <shared-home-staffer-badges [horizontalOnly]="true" class="client-view" [userData]="staffer.staffer">
          </shared-home-staffer-badges>
        </div>
      </div>
    </div>

    <div class="performance-stats">
      <div class="reliability-stat">
        <app-semi-circle-progress-bar *ngIf="staffer?.staffer" 
          [progress]="staffer.staffer.reliabilityRating" 
          [userData]="staffer.staffer" 
          [staffer]="userData">
        </app-semi-circle-progress-bar>
      </div>
    </div>
  </div>

  <!-- Attendance Info (if any) -->
  <div class="attendance-container" *ngIf="jobItem">
    <app-shift-attendance-info
      [jobItem]="jobItem"
      [showPhoneNumber]="shouldShowPhoneNumber"
      [staffer]="staffer.staffer">
    </app-shift-attendance-info>
  </div>

  <!-- Expandable Details -->
  <div class="card-accordion">
    <!-- Contractor Details -->
    <div class="accordion-item" [class.is-open]="showContractorDetails">
      <div class="accordion-header" (click)="showContractorDetails = !showContractorDetails">
        <div class="header-label">
          <i class="fas fa-user-tag icon-accent"></i>
          <span>Contractor Details</span>
        </div>
        <i class="fas fa-chevron-down toggle-icon"></i>
      </div>
      <div class="accordion-content" *ngIf="showContractorDetails">
        <div class="detail-grid">
          <div class="indicators-detail">
            <shared-signals-indicators [userData]="staffer.staffer">
            </shared-signals-indicators>
          </div>
          <div class="detail-item" *ngIf="staffer.hasContractorWorkedInUnit">
            <i class="fas fa-check-circle text-success"></i>
            <span>Already worked in unit</span>
          </div>
          <div class="detail-item" *ngIf="staffer.distanceFromShift">
            <i class="fas fa-map-marker-alt text-danger"></i>
            <span>{{staffer.isProvinceNY ? staffer.distanceInMiles : staffer.distanceInKm}} {{staffer.isProvinceNY ? 'MI' : 'KM'}} away</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Bulletins -->
    <div class="accordion-item" *ngIf="bulletins.length" [class.is-open]="showBulletinDetails">
      <div class="accordion-header" (click)="showBulletinDetails = !showBulletinDetails">
        <div class="header-label">
          <i class="fas fa-clipboard-list icon-accent"></i>
          <span>Bulletins</span>
          <span class="badge-count">{{bulletins.length}}</span>
        </div>
        <i class="fas fa-chevron-down toggle-icon"></i>
      </div>
      <div class="accordion-content" *ngIf="showBulletinDetails">
        <div class="bulletin-list">
          <div *ngFor="let bulletin of bulletins" class="bulletin-card" (click)="showBulletin(bulletin)">
            <div class="bulletin-main">
              <i class="fas fa-file-pdf bulletin-icon"></i>
              <div class="bulletin-info">
                <span class="bulletin-title">{{bulletin.name}}</span>
                <span class="bulletin-date" [class.acknowledged]="bulletin.acknowledgment_date">
                  {{bulletin.acknowledgment_date ? 'Acknowledged on ' + bulletin.acknowledgment_date : 'Pending acknowledgment'}}
                </span>
              </div>
            </div>
            <i *ngIf="bulletin.acknowledgment_date" class="fas fa-check-circle ack-icon"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- History -->
    <div class="accordion-item" *ngIf="!viewingHistory" [class.is-open]="showHistoryDetails">
      <div class="accordion-header" (click)="loadContractorHistory(staffer.staffer._id)">
        <div class="header-label">
          <i class="fas fa-history icon-accent"></i>
          <span>History</span>
        </div>
        <i class="fas fa-chevron-down toggle-icon"></i>
      </div>
      <div class="accordion-content" *ngIf="showHistoryDetails">
        <div class="history-grid">
          <div class="history-item">
            <div class="item-icon"><i class="fas fa-tasks"></i></div>
            <div class="item-data">
              <span class="item-label">Shifts Worked</span>
              <span class="item-value" *ngIf="!shiftHistoryStats?.shifts_worked">0</span>
              <span class="item-value link" *ngIf="shiftHistoryStats?.shifts_worked" (click)="viewShiftDetails(true); $event.stopPropagation()">
                {{ shiftHistoryStats.shifts_worked }} <span class="see-more">See details</span>
              </span>
            </div>
          </div>
          <div class="history-item">
            <div class="item-icon"><i class="fas fa-graduation-cap"></i></div>
            <div class="item-data">
              <span class="item-label">Training</span>
              <span class="item-value">{{ shiftHistoryStats?.trainingComplete ? (shiftHistoryStats.trainingComplete | momentPipeUnix:'MMM DD, YYYY') : 'N/A' }}</span>
            </div>
          </div>
          <div class="history-item">
            <div class="item-icon"><i class="fas fa-hospital"></i></div>
            <div class="item-data">
              <span class="item-label">Units</span>
              <span class="item-value" *ngIf="!shiftHistoryStats?.unitsWorked?.length">None</span>
              <span class="item-value link" *ngIf="shiftHistoryStats?.unitsWorked?.length" (click)="viewUnitNumbers(); $event.stopPropagation()">
                {{ shiftHistoryStats.unitsWorked.length }} <span class="see-more">See details</span>
              </span>
            </div>
          </div>
          <div class="history-item">
            <div class="item-icon"><i class="fas fa-calendar-alt"></i></div>
            <div class="item-data">
              <span class="item-label">Future Shifts</span>
              <span class="item-value" *ngIf="!shiftHistoryStats?.futureShifts">0</span>
              <span class="item-value link" *ngIf="shiftHistoryStats?.futureShifts" (click)="viewShiftDetails(false); $event.stopPropagation()">
                {{ shiftHistoryStats.futureShifts }} <span class="see-more">See details</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
